(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-collection-activity-offers"] && !window.DesignMode) return;
  try {
    
;
(function (){
    "use strict";

    $(".benefits-collection-activity-offers a").on("click", function (e) {
        const $this = $(this);
        const link = location.origin + $this.attr("href");
        const buttonName = $this.find("h3").text().trim();

        const $tabsNav = $this.closest("jky-v-tabs-content").prev();
        let position = "";
        let module = "ActivityBasedOffers"
        if ($tabsNav.length) {
            position = $tabsNav.find(".navigation-item.active").text().trim();
            module = $tabsNav.prev().find(".blocks-content-heading").find("div:first-child").text().trim();
        }

        window.dataLayer.push({event_parameters: null});
        window.dataLayer.push({
            event: "ga4Event",
            event_name: "promo_collection_user_clicks",
            event_parameters: {
                current_page: window.location.href,
                module: module,
                position: position,
                button_name: buttonName,
                link: link
            }
        });
    });

    const initSwiper = (swiper) => {
        new Swiper(swiper, {
            slidesPerView: 'auto',
            pagination: {el: '.benefits-collection-activity-offers .swiper-pagination', clickable: true},
            spaceBetween: 24,
            navigation: {
                nextEl: '.benefits-collection-activity-offers .swiper-button-next',
                prevEl: '.benefits-collection-activity-offers .swiper-button-prev',
            },
            breakpoints: {
                1400: {
                    spaceBetween: 20,
                },
                1024: {
                    spaceBetween: 15,
                }
            }
        });
    };

    const init = () => {
        const url = "/osadminapi/v1/old-invite-new/get-coupon-info?shopifyShopId=" + window.shopId;
        window.Jackery.Utils.get(url).then(function (res) {
            if (res && res.code === 200) {
                const data = res.data;
                document.querySelectorAll('.benefits-collection-activity-offers .swiper').forEach(swiper =>  {
                    const $swiper = $(swiper);
                    $swiper.find(".description").each(function() {
                        const newHtml = $(this).html()
                            .replace("{new_subscribe_welfare}", data.newSubscribeTitle)
                            .replace("{old_subscribe_welfare}", data.newSubscribeToOldTitle)
                            .replace("{old_purchase_welfare}", data.newPurchaseToOldTitle);
                        $(this).html(newHtml);
                    });
                    let slidesCond = 3;
                    if (window.Jackery.Utils.isLessThan1024Screen()) {
                        slidesCond = 1;
                    }
                    if ($swiper.find(".swiper-slide").length > slidesCond) {
                        initSwiper(swiper);
                    } else {
                        $swiper.addClass("not");
                    }
                });
            }
        }).catch(function (err) {
            console.error("Get titles failed:", err);
        });
    };

    document.addEventListener('DOMContentLoaded', () => init());

    document.addEventListener('shopify:section:load', () => init());
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-collection-coupons-display"] && !window.DesignMode) return;
  try {
    
;(function(){
    "use strict";

        document.addEventListener('DOMContentLoaded', () => {
            if (Jackery.Utils.isMobile()) {
                document.querySelectorAll('.benefits-collection-coupons-display .swiper').forEach(swiper => {
                    new Swiper(swiper, {
                        slidesPerView: 'auto',
                        pagination: {el: '.swiper-pagination', clickable: true}
                    });
                });
            }
        });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-collection-promo-product"] && !window.DesignMode) return;
  try {
    
;
(function () {
  "use strict";

  $(document).on("click", ".benefits-collection-promo-product jds-button", function (e) {
    const module = getModule($(this));
    const button_name = $(this).text();
    const link = location.origin + $(this).attr("href");
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "promo_collection_user_clicks",
      event_parameters: {
        current_page: window.location.href,
        module: module,
        button_name: button_name,
        link: link
      }
    });
  });

  $(document).on("click", ".benefits-collection-promo-product a", function (e) {

    const module = getModule($(this));

    const link = $(this).attr("href");
    const position = $(this).closest(".flex__item").find('.product-title').text();

    let button_name = 'pic';
    if ($(this).parent().hasClass('product-content')) {
      button_name = $(this).closest('.product-flex__list').data('productButtonText') || "VIEW MORE";
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "promo_collection_user_clicks",
      event_parameters: {
        current_page: window.location.href,
        module: module,
        position: position,
        button_name: button_name,
        link: link
      }
    });
  });

  function getModule($this) {
    const $prevSection = $this.closest('.benefits-collection-promo-product').parent().prev();
    let module = 'InstantDeals';
    if ($prevSection.attr('id').indexOf('benefits_collection_common_title') !== -1) {
      module = $prevSection.find(".title").text();
    }
    return module;
  }

  function initProducts() {
    const $productList = $(".benefits-collection-promo-product .product-flex__list");
    $productList.each(function () {
      const $this = $(this);
      if ($this.children().length == 0) {
        const url = "/osadminapi/v1/goods/get-sales-rank-goods-list?limit=4&shopifyShopId=" + window.shopId + "&categoryNumList=" + $this.data("productCategories");
        window.Jackery.Utils.get(url).then(function (res) {
          if (res && res.code === 200) {
            const product = {};
            const buttonText = $this.data("productButtonText") || "VIEW MORE";
            const autoDiscountPrice = $this.data("autoDiscountPrice");
            const discountDisplayStyle = $this.data("discountDisplayStyle");
            const discountAmountDisplayStyle = $this.data("discountAmountDisplayStyle");
            const discountTagDisplayStyle = $this.data("discountTagDisplayStyle");
            for (let i = 0; i < res.data.length; i++) {
              const product = res.data[i];
              const productUrl = location.origin + "/products/" + product.handle + "?variant=" + product.skuId;
              let productLabel = '';
              if (product.promotion) {
                productLabel = product.promotion
              } else {
                if (autoDiscountPrice && product.priceOff > 0) {
                    if (discountTagDisplayStyle === 'amount') {
                        const money = formatMoney(parseFloat(product.autoDiscountAmount)).split('.')[0];
                        productLabel = discountAmountDisplayStyle.replace('()', money);
                    } else {
                        productLabel = discountDisplayStyle.replace('()', product.priceOff);
                    }
                }
              }
              const price = product.price ? formatMoney(parseFloat(product.price)) : '';
              const originalPrice = product.originalPrice ? formatMoney(parseFloat(product.originalPrice)) : `<span class="opacity-0">&nbsp;</span>`;
              let domHtml =
                `<div class="flex__item h-[19.125rem] lg:h-[28rem] w-[10.47rem] lg:w-[19.5625rem]">
                  <div class="relative rounded-[0.375rem] lg:rounded-xl flex flex-col justify-between px-[0.5rem] lg:px-5 bg-white h-full">
                    <a href="${productUrl}" target="_blank">
                      <div class="product-img focus-zoom-container overflow-hidden pt-[0.25rem] lg:pt-0 w-[8.25rem] lg:w-[16.25rem] h-[8.25rem] lg:h-[16.25rem] mx-[0.625rem] lg:mx-[0.375rem]">
                        <img class="object-cover focus-zoom blur-up lazyload w-full" src="${product.image}" data-src="${product.image}" alt="" loading="lazy">
                      </div>
                    </a>
                    <div class="product-content flex flex-col pt-[0.125rem] lg:pt-[0.5625rem]">
                      <div class="product-content-main flex flex-col justify-between">
                        <div class="product-title h-[2.6875rem] lg:h-[3.5rem] font-medium text-[0.875rem] leading-[1.375rem] lg:text-[1rem] text-[#1A1A1A] lg:leading-[1.625rem] text-overflow-2 mb-[0.78rem] lg:mb-4">
                          ${product.title}
                        </div>
                        <div class="product-prices flex flex-col lg:flex-row lg:items-center gap-[0.5rem] lg:gap-2">
                          <div class="price price--on-sale font-semibold text-[1.125rem] lg:text-2xl text-[#FD5000] leading-[1.5rem] lg:leading-8">
                            <div class="real-price">${price}</div>
                          </div>
                          <div class="origin-price font-400 origin-compare-price font-normal text-[0.875rem] lg:text-base text-[#999999] lg-[0.75rem] lg:leading-6 line-through">
                            ${originalPrice}
                          </div>
                        </div>
                      </div>
                      <a class="flex items-center justify-center w-full h-[2rem] lg:h-9 border rounded-[1.125rem] bg-[#FD5000] border-solid border-[#FD5000] mt-[0.5rem] mb-[1rem] lg:mt-[1rem] lg:mb-6
                                                font-medium lg:font-semibold lg:text-base text-[0.75rem] text-white leading-[1.25rem] lg:leading-4"
                         href="${productUrl}"
                         target="_blank">${buttonText}</a>
                    </div>
                    <div class="product-label-tag product-tag-text">
                      <span class="product-label-tag-text">${productLabel}</span>
                    </div>
                    `;
              if (product.icon) {
                domHtml += `<div class="product-label-tag product-tag-img">
                              <img src="${product.icon}" alt="product tag image" loading="lazy">
                            </div>
                        </div></div>`;
              } else {
                domHtml += `</div></div>`;
              }
              $this.append(domHtml);
            }
          }
        }).catch(function (err) {
            console.error("Get products failed:", err);
        });
      }
    });
  }

  document.addEventListener('shopify:section:load', initProducts);

  document.addEventListener('DOMContentLoaded', initProducts);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-collection-special-group"] && !window.DesignMode) return;
  try {
    
;
$(function () {
    "use strict";

    $(".benefits-collection-special-group jds-button").on("click", function () {
        const $this = $(this);
        const $titleComp = $this.closest('.benefits-collection-special-group').parent().prev();
        let module = "SpecialGroupBenefits";
        if ($titleComp.attr("id") && $titleComp.attr("id").indexOf("benefits_collection_common_title") !== -1) {
            module = $titleComp.find('.title').text().trim() || module;
        }
        let position = "";
        try {
            position = $this.parent().parent().prev().find(".blocks-content-heading").find("div:first-child").text().trim();
        } catch (e) {}
        const buttonName = $this.text().trim();
        let link = $this.attr("href");
        if (link) {
            link = location.origin + link;
        } else {
            link = "";
        }

        window.dataLayer.push({event_parameters: null});
        window.dataLayer.push({
            event: "ga4Event",
            event_name: "promo_collection_user_clicks",
            event_parameters: {
                current_page: window.location.href,
                module: module,
                position: position,
                button_name: buttonName,
                link: link
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-new"]) return;
  try {
    
  function toGA(data){
    if(data.response && data.response.code === 200){
      const msg = $('.footer-new .newbee-form_submit button').data('success') || data.response.message
      pushSuccessMessage(msg);
      const button_name =$('.footer-new .newbee-form_submit button').text()
      let params ={
        module: 'Footer Subscribe',
        button_name: button_name
      }

      window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: "ga4Event",
          event_name: "footer_user_clicks4.0",
          event_parameters: {
            current_page: window.location.href, // current page url
            ...params
          }
        });
    }
    
  }
  window.toGA = toGA

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-photovolatic-media"] && !window.DesignMode) return;
  try {
    
;
(function(){
    "use strict";

    $(document).on('click', '.section-photovolatic-media .action-btn.next-action', function(e) {
        const $this = $(this).parent().parent();
        const $container = $this.find(".jky-tabs-scroll-inner");
        $container.css("scroll-behavior", "smooth")
        $container.scrollLeft($container.scrollLeft() + 120);
    });

    $(document).on('click', '.section-photovolatic-media .action-btn.prev-action', function(e) {
        const $this = $(this).parent().parent();
        const $container = $this.find(".jky-tabs-scroll-inner");
        $container.css("scroll-behavior", "smooth")
        $container.scrollLeft($container.scrollLeft() - 120);
    });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v-tabs-sections"] && !window.DesignMode) return;
  try {
    
if (!customElements.get("jky-v-tabs-content")) {
  class JkyVTabsContent extends HTMLElement {
    constructor() {
      super()
      this.navItemLength = 0
    }
    connectedCallback() {
      this.container = this.closest('.blocks-tabs-sections')
      this.tabContentWrap = this.querySelector('.tab-content-wrap')
      this.init()

      // 监听 子组件高度变化 事件
      this.updateChildHeight = this.updateChildHeight.bind(this)
      document.addEventListener('tabChildUpdateHeight', this.updateChildHeight)
    }
    disconnectedCallback() {
      // 移除事件监听
      document.removeEventListener('tabChildUpdateHeight', this.updateChildHeight)
    }
    init() {
      const vTabsNavigation = this.container?.querySelector('jky-v-tabs-navigation')
      if (!vTabsNavigation) return
      
      const navItems = vTabsNavigation.querySelectorAll('.navigation-item');
      this.navItemLength = navItems.length

      const groupNames = Array.from(navItems).map(item => item.dataset.groupName);
      groupNames.forEach(groupName => {
        // 创建一个新的 tab 内容容器
        const tabContent = document.createElement('div')
        tabContent.classList.add('tab-content', 'w-full', 'invisible')
        tabContent.setAttribute('data-group-name', groupName)
        // 将内容添加到对应的组中
        const groupTargets = document.querySelectorAll(`[belongs-to-target="${groupName}"]`)
        if (groupTargets.length > 0) {
          groupTargets.forEach((section, index) => {
            section.classList.remove('hidden')
            tabContent.appendChild(section)
            index === 0 && tabContent.classList.remove('invisible')
          });
        }
        this.tabContentWrap.appendChild(tabContent)
      })

      // 确保所有内容都已渲染
      this.tabContents = this.tabContentWrap.querySelectorAll('.tab-content')

      // 设置 tabContent 的宽度，以及 tab content wrap 的宽度、高度
      requestAnimationFrame(() => {
        if (this.navItemLength > 0) {
          this.tabContentWrap.style.width = `${this.navItemLength * 100}%`
          this.tabContentWrap.style.height = `${this.tabContents[0].offsetHeight}px`
          this.tabContents.forEach((item, idx) => item.style.width = `${100 / this.navItemLength}%`)
        }
      })
    }
    handleChildAction({ item, index, isActive }) {
      requestAnimationFrame(() => {
        this.tabContentWrap.style.transform = `translateX(-${index * 100 / this.navItemLength}%)`
        this.tabContentWrap.style.height = `${this.tabContents[index].offsetHeight}px`

        // 滚动到当前项
        const itemParent = item.closest('jky-v-tabs-navigation')
        const bottom = parseInt(itemParent?.getBoundingClientRect()?.bottom) || 0
        const top = parseInt(this.tabContentWrap.getBoundingClientRect().top) || 0
        window.scrollTo({
          top: top - bottom + window.scrollY,
          behavior: isActive ? 'smooth' : 'auto' // 只有点击当前项时才平滑滚动
        })

        this.tabContents.forEach((it, idx) => {
          if (idx === index) {
            it.classList.remove('invisible')

            // Safari 修复: 自动匹配 line-clamp-[n]
            const els = it.querySelectorAll('[class*="line-clamp-"]');
            if (!els.length) return;
            requestAnimationFrame(() => {
              // 先拉大
              els.forEach(el => {
                el.style.display = '-webkit-box';
                el.style.webkitBoxOrient = 'vertical';
                el.style.overflow = 'hidden';
                el.style.whiteSpace = 'normal';
                el.style.webkitTransform = 'translateZ(0)';
                el.style.webkitLineClamp = '999'; // 拉大，触发回流
              });

              requestAnimationFrame(() => {
                els.forEach(el => {
                  const match = Array.from(el.classList).find(c => /^line-clamp-(\d+)$/.test(c));
                  if (!match) return;
                  const n = +match.match(/\d+/)[0];

                  // 设回目标 clamp
                  el.style.webkitLineClamp = n;
                  void el.offsetHeight; // 强制 reflow
                });
              });
            });
          } else {
            it.classList.add('invisible')
          }
        })
      })
    }
    // 更新子组件高度
    updateChildHeight(e) {
      const { height } = e.detail;
      if (height >= 0) {
        this.tabContentWrap.style.height = `${height}px`;
      }
    }
  }
  customElements.define('jky-v-tabs-content', JkyVTabsContent);
}

  } catch(e) { console.error(e); }
})();
})();
